/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { RegistryResponse } from '../../models/registry-response';

export interface RegistryControllerGetAll$Params {
  query?: string;
  slug?: string;
  main_contact?: string;
  vat_number?: string;
  country_iso?: string;
  province?: string;
  city?: string;
  contact_type?: number;
  limit: number;
  skip: number;
}

export function registryControllerGetAll(http: HttpClient, rootUrl: string, params: RegistryControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, registryControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('slug', params.slug, {});
    rb.query('main_contact', params.main_contact, {});
    rb.query('vat_number', params.vat_number, {});
    rb.query('country_iso', params.country_iso, {});
    rb.query('province', params.province, {});
    rb.query('city', params.city, {});
    rb.query('contact_type', params.contact_type, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryResponse;
      }>;
    })
  );
}

registryControllerGetAll.PATH = '/registry';
